import * as React from 'react';
import { Box, Paper, IconButton, Tooltip } from '@mui/material';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { AuthorsSelector } from './AuthorsSelector';
import { SearchText } from './SearchText';
import { SearchTypeSelector } from './SearchTypeSelector';
import { LiveFormatSelector } from './LiveFormatSelector';
import { LiveContentSelector } from './LiveContentSelector';
import { DateRangeSelector } from './DateRangeSelector';
import { context } from '../context';

export const SearchBox = () => {
    const { 
        setSelectedFormat, 
        setSelectedContent, 
        setStartDate, 
        setEndDate, 
        onSearch,
        searchWord,
        selectedFormat,
        selectedContent,
        startDate,
        endDate,
        setSearchType
    } = React.useContext(context);

    // 检查是否有任何筛选条件被设置
    const hasFilters = searchWord || selectedFormat || selectedContent || startDate || endDate;

    // 清空所有筛选条件
    const handleClearAll = () => {
        setSelectedFormat('');
        setSelectedContent('');
        setStartDate('');
        setEndDate('');
        onSearch('');
        setSearchType('subtitle');
    };

    return (
        <Paper 
            elevation={0}
            sx={{ 
                p: { xs: 2, sm: 2.5 },
                borderRadius: '12px',
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
            }}
        >
            <Box sx={{ 
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                gap: { xs: 2, sm: 2 },
                alignItems: { lg: 'center' },
            }}>
                {/* Filter Controls */}
                <Box sx={{ 
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1.5,
                    alignItems: 'center',
                    flex: { lg: '0 0 auto' },
                }}>
                    <Box sx={{ minWidth: { xs: '140px', sm: '160px' } }}>
                        <AuthorsSelector />
                    </Box>
                    <Box sx={{ minWidth: { xs: '120px', sm: '140px' } }}>
                        <LiveFormatSelector />
                    </Box>
                    <Box sx={{ minWidth: { xs: '120px', sm: '140px' } }}>
                        <LiveContentSelector />
                    </Box>
                    <DateRangeSelector />
                </Box>
                
                {/* Search Input */}
                <Box sx={{ 
                    flex: 1, 
                    minWidth: { xs: '100%', lg: '240px' },
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                }}>
                    <SearchTypeSelector />
                    <Box sx={{ flex: 1 }}>
                        <SearchText />
                    </Box>
                    <Tooltip title="清空所有筛选">
                        <span>
                            <IconButton
                                onClick={handleClearAll}
                                disabled={!hasFilters}
                                size="small"
                                sx={{
                                    color: hasFilters ? 'primary.main' : 'action.disabled',
                                    bgcolor: hasFilters ? 'primary.50' : 'transparent',
                                    border: '1px solid',
                                    borderColor: hasFilters ? 'primary.200' : 'divider',
                                    borderRadius: '8px',
                                    p: 1,
                                    '&:hover': {
                                        bgcolor: hasFilters ? 'primary.100' : 'transparent',
                                    },
                                    '&.Mui-disabled': {
                                        borderColor: 'divider',
                                    },
                                    transition: 'all 0.2s ease-in-out',
                                }}
                            >
                                <ClearAllIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
            </Box>
        </Paper>
    );
}